<!-- Read-only display of a submitted gender answer, translated to its label. -->

<script lang="ts" setup>
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { computed } from 'vue';

import type { GenderInputValue } from '@sigma/common/forms/GenderInput.js';
import { GenderTranslation } from '@sigma/common/models/Gender.js';

interface Props {
  /** The gender answer value to display. */
  value: GenderInputValue;
}

const props = defineProps<Props>();

const t = useTranslate();

const genderLabel = computed(() => t(GenderTranslation, props.value.gender));
</script>

<template>
  {{ genderLabel }}
</template>
